var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.apptype.entrance"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "entranceId"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                allowClear: "",
                                placeholder:
                                  _vm.language["column.pleaseChoose"] +
                                  _vm.language["emp.apptype.entrance"],
                                disabled: _vm.formDisabled
                              },
                              model: {
                                value: _vm.model.entranceId,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "entranceId", $$v)
                                },
                                expression: "model.entranceId"
                              }
                            },
                            _vm._l(_vm.entrances, function(item, index) {
                              return _c(
                                "a-select-option",
                                {
                                  key: index.toString(),
                                  attrs: { value: item.id }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.entranceName) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.commonlink.linkNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "linkNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.language["trmorder.auto"],
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.linkNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "linkNo", $$v)
                              },
                              expression: "model.linkNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.commonlink.linkName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "linkName"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.commonlink.linkName"],
                              maxLength: "100",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.linkName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "linkName", $$v)
                              },
                              expression: "model.linkName"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "emp_entrance_common_link",
                                    "link_name",
                                    _vm.linkNameLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.commonlink.linkUrl"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "linkUrl"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.commonlink.linkUrl"],
                              maxLength: "255",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.linkUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "linkUrl", $$v)
                              },
                              expression: "model.linkUrl"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              this.language["emp.commonlink.default"] +
                              this.language["ad.image"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "imageUrl"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            attrs: {
                              text: this.language["common.uploadButton"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.imageUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "imageUrl", $$v)
                              },
                              expression: "model.imageUrl"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              this.language["emp.commonlink.hover"] +
                              this.language["ad.image"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "hoverImageUrl"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            attrs: {
                              text: this.language["common.uploadButton"],
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.hoverImageUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "hoverImageUrl", $$v)
                              },
                              expression: "model.hoverImageUrl"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.apptype.sort"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["emp.apptype.sort"],
                              min: 1,
                              max: 999999,
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.apptype.status"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "status"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              "trigger-change": true,
                              dictCode: "sys_portal_up_down",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["basedata.remark"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["basedata.remark"],
                              maxLength: _vm.ml,
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("language-model", {
            ref: "languageModel",
            on: { ok: _vm.languageOk }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }